import * as yup from 'yup';

export const ClienteRelatorioSchema = yup.object().shape({
    cliente_id: yup.number()
      .transform((value, originalValue) => originalValue === "" ? null : value)
      .nullable()
      .typeError('Deve ser um número')
      .min(0, 'Código deve ser maior ou igual a zero')
});
